module.exports = __webpack_public_path__ + "img/LOGO@2x.f1f5baad.png";